<template>
  <v-application v-if="access.item_modifiers">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="modifier"
          v-bind:headers="headers"
          v-bind:data="modifers"
          v-bind:save="save_modifier"
          v-bind:row="typing_modifier"
          v-bind:remove="remove_modifiers"
          v-bind:num-pages="modifers_total"
          v-model="modifers_page"
          v-bind:numPages="numPages"
          v-bind:add_button_name="'add_modifier'"
          ItemModifier
          :data_loading="data_loading"
          @change-pagination="changePagination"
          v-bind:saveDisabled="saveDisabled"
        >
          <template #top>
            <v-layout>
              <v-spacer />
              <v-flex md6>
                <v-combobox
                  v-model="store"
                  label="Stores"
                  v-bind:items="stores"
                  item-text="name"
                  hide-details
                />
              </v-flex>
            </v-layout>
          </template>
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field
                v-model="modifier.name"
                ref="name"
                :rules="[fieldRules.required]"
                :label="$t('modifier_name')"
                hide-details
              />
            </v-card-text>
            <v-list>
              <v-list-item
                v-for="(option, index) in modifier.options"
                v-bind:key="index"
              >
                <v-list-item-content>
                  <v-layout>
                    <v-flex>
                      <v-text-field
                        v-model="option.option_name"
                        :ref="'option_name' + index"
                        :rules="[fieldRules.required]"
                        :label="$t('option_name')"
                        class="mx-2"
                      />
                    </v-flex>
                    <v-flex>
                      <vuetify-money
                        v-model="option.price"
                        :ref="'price' + index"
                        :rules="[fieldRules.required]"
                        :label="$t('price')"
                        class="mx-2"
                        v-bind:options="moneyOptions"
                      />
                    </v-flex>
                  </v-layout>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon v-on:click="modifiers_remove_option(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-card-text>
              <v-btn
                text
                outlined
                color="primary"
                v-on:click="modifiers_add_option"
              >
                <v-icon>mdi-plus</v-icon>
                {{ $t("add_option") }}
              </v-btn>
            </v-card-text>
            <v-card-text>
              <v-list class="px-2">
                <v-list-item
                  v-for="(service, index) in modifier.services"
                  v-bind:key="index"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      service.service_name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-switch v-model="service.available" />
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Modifiers from "../../mixins/items/modifiers";
export default {
  name: "Modifiers",
  mixins: [Modifiers],
  data: () => ({
    headers: [{ text: "Modifier", value: "name" }],
    is_valid: false,
  }),
  computed: {
    form() {
      const formObj = {
        name: this.modifier.name,
      };
      for (let i = 0; i < this.modifier.options.length; i++) {
        formObj["option_name" + i] = this.modifier.options[i].option_name;
        formObj["price" + i] = this.modifier.options[i].price;
      }
      return formObj;
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  methods: {
    changePagination(page) {
      this.modifers_page = page;
      this.update_modifiers();
    },
  },
  mounted() {
    this.headers = [{ text: this.$t("modifier"), value: "name" , available: true}];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
